/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingTextFeaturesQueryResponse, GetDrawingTextFeaturesPathParams, GetDrawingTextFeatures422 } from "../models/drawingClient/GetDrawingTextFeatures";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingTextFeaturesUrl(project_uuid: GetDrawingTextFeaturesPathParams["project_uuid"], file_uuid: GetDrawingTextFeaturesPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/text` as const }  
  return res
}

/**
 * @description Returns a GZipped GeoJSON FeatureCollection that contains all of the text features of the specified drawing file. Each feature's geometry is described as a standard GeoJSON point.
 * @summary Get text features for a drawing as GeoJSON feature collection
 * {@link /v1/drawings/:project_uuid/:file_uuid/text}
 */
export async function getDrawingTextFeatures(project_uuid: GetDrawingTextFeaturesPathParams["project_uuid"], file_uuid: GetDrawingTextFeaturesPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingTextFeaturesQueryResponse, ResponseErrorConfig<GetDrawingTextFeatures422>, unknown>({ method : "GET", url : getGetDrawingTextFeaturesUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}